import React, { useEffect, useRef } from 'react';
import { Button, Uploader } from 'rsuite';

const MAX_FILESIZE_IN_BYTES = 4194304;
const MIN_FILESIZE_IN_BYTES = 15360;

const DocumentUpload = ({
  allowMultiple = true,
  onChange = () => null,
  onError = () => null,
  fileList,
  validExtensions = ['*/*'],
  maxDocuments = 20,
  ariaLabel = '',
}) => {
  const ref = useRef();

  useEffect(() => {
    if (!ref?.current) return;
    let target = ref.current.root.querySelector('input');
    if (target) {
      target.setAttribute('aria-label', `${ariaLabel}-label`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current]);

  const onDocumentUploadChanged = (_value) => {
    let value;
    let doChange = true;
    if (_value && _value.length > 0) {
      value =
        _value.length > maxDocuments ? _value.slice(0, maxDocuments) : _value;
      doChange = _value.every((v) => isValidFileType(v.blobFile));
    }

    if (doChange) {
      onError('');
      onChange(value);
    }
  };

  const isValidFileType = (blob) => {
    const extensionDict = {
      '.jpg': 'image/jpeg',
      '.jpeg': 'image/jpeg',
      '.png': 'image/png',
      '.pdf': 'application/pdf',
      '.heic': 'image/heic',
    };

    let splitFileName = blob.name.split('.');
    let fileExtension = `.${splitFileName[splitFileName.length - 1].toLowerCase()}`;
    let hasValidExtension = Object.keys(extensionDict).includes(fileExtension);
    if (!hasValidExtension) return false;
    return blob.type === extensionDict[fileExtension];
  };

  const isValidFileSize = (blob) => {
    return (
      blob.size >= MIN_FILESIZE_IN_BYTES && blob.size <= MAX_FILESIZE_IN_BYTES
    );
  };

  const onShouldUpdateQueue = (queue) => {
    if (queue?.length > maxDocuments) {
      onError('Selected file number exceeds the maximum number of documents.');
      return false;
    }
    if (!queue.every((q) => isValidFileType(q.blobFile))) {
      onError('One or more selected documents is not a valid file type.');
      return false;
    }
    if (!queue.every((q) => isValidFileSize(q.blobFile))) {
      onError(
        'One or more selected documents are not within acceptable file size limits.'
      );
      return false;
    }
    return true;
  };
  return (
    <>
      <Uploader
        ref={ref}
        fileList={fileList}
        multiple={allowMultiple}
        autoUpload={false}
        shouldQueueUpdate={onShouldUpdateQueue}
        onChange={onDocumentUploadChanged}
        accept={`${validExtensions.join(', ')}`}
      >
        <Button data-cy={ariaLabel}>Select files...</Button>
      </Uploader>
    </>
  );
};

export default DocumentUpload;
